import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WidgetWrapper } from '@/src/components/projects/ProjectDashboard/WidgetWrapper.jsx';
import { WidgetInner } from '@/src/components/projects/ProjectDashboard/WidgetInner.jsx';
import { WidgetCard } from '@/src/components/projects/ProjectDashboard/WidgetCard.jsx';
import SentimentDot from '@/src/components/SentimentDot.jsx';
import { StakeholderProfileLink } from '@/src/components/links/index.jsx';
import Empty from '@/src/components/Empty.jsx';
import { stakeholdersOverviewWidgetContent } from '@/src/components/EmptyStates.jsx';
import { buildPath } from '@/src/components/Link.jsx';
import { STAKEHOLDERS_INDEX } from '@/src/constants/routes.js';

export const StakeholdersWidget = ({ data, projectId }) => {
  const navigate = useNavigate();
  const { slug, projectId: paramProjectId } = useParams();

  const handleNavigateToStakeholders = () => {
    const path = buildPath(STAKEHOLDERS_INDEX, {
      slug,
      projectId: projectId || paramProjectId,
    });
    navigate(path);
  };

  const stakeholders = data || [];
  const total = stakeholders.length;
  const hasData = stakeholders.length > 0;

  return (
    <WidgetWrapper className="stakeholders-widget">
      <div className="flex align-center m-b-12">
        <h2>Stakeholders Overview</h2>
        <strong className="header-item bordered component-bg-white text-primary">
          <span className="text-muted">Total: </span>
          <span>{total}</span>
        </strong>
      </div>
      {hasData ? (
        <WidgetInner height={500} className="flex flex-col flex-align-start">
          {stakeholders.map((stakeholder) => (
            <WidgetCard
              key={stakeholder.id}
              sentiment={stakeholder.sentiment || 'default'}
              className="p-x-20 p-y-16 m-b-16 w-100"
            >
              <div className="left">
                <StakeholderProfileLink
                  stakeholderId={stakeholder.id}
                  projectId={projectId}
                >
                  <span className="font-size-18 font-semibold">
                    {stakeholder.name}
                  </span>
                </StakeholderProfileLink>
              </div>
              <div className="right">
                <div className="flex align-center flex-justify">
                  <div className="flex align-center">
                    {stakeholder.sentiment !== 'empty' ? (
                      <>
                        <SentimentDot sentiment={stakeholder.sentiment} />
                        <div className="font-size-16 font-semibold">
                          {stakeholder.sentiment
                            .split('-')
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() + word.slice(1)
                            )
                            .join(' ')}
                        </div>
                      </>
                    ) : (
                      '—'
                    )}
                  </div>
                </div>
              </div>
            </WidgetCard>
          ))}
        </WidgetInner>
      ) : (
        <WidgetInner height={500} className="flex flex-col">
          <Empty
            simplified
            content={stakeholdersOverviewWidgetContent}
            action={handleNavigateToStakeholders}
          />
        </WidgetInner>
      )}
    </WidgetWrapper>
  );
};
